// Choices sets customProperties to an object when the option has no data-custom-properties.
const flagOf = (data) =>
    typeof data.customProperties === "string" ? data.customProperties : "";

export const useLanguageSelector = () => {
    const callbackOnCreateTemplates = (strToEl) => ({
        item: function ({ classNames }, data) {
            // For the current selected option.
            const customProperties = flagOf(data);
            const css = [
                classNames.item,
                data.highlighted
                    ? classNames.highlightedState
                    : classNames.itemSelectable,
            ];
            const attrs = [
                "data-item",
                `data-id="${data.id}"`,
                `data-value="${data.value}"`,
            ];
            if (data.active) {
                attrs.push('aria-selected="true"');
            }
            if (data.disabled) {
                attrs.push('aria-disabled="true"');
            }

            return strToEl(`
                    <div class="${css.join(" ")}" ${attrs.join(" ")}>
                        ${customProperties ? `<img class="size-6" src="${customProperties}" alt=""/>` : ""}
                        <span>${data.label}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="shrink-0 size-6 text-white transition-transform duration-200" width="24" height="24" viewBox="0 0 24 24" data-slot="trailingIcon">
                            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m6 9l6 6l6-6" />
                        </svg>
                    </div>
                `);
        },
        choice: function ({ classNames }, data) {
            // For every option in the select.
            const customProperties = flagOf(data);
            const css = [classNames.item, classNames.itemChoice];
            css.push(
                data.disabled
                    ? classNames.itemDisabled
                    : classNames.itemSelectable
            );
            // `data-select-text="${data.itemSelectText}"`,
            const attrs = [
                "data-choice",
                `data-id="${data.id}"`,
                `data-value="${data.value}"`,
            ];
            attrs.push(
                data.disabled
                    ? 'data-choice-disabled aria-disabled="true"'
                    : "data-choice-selectable"
            );
            attrs.push(data.groupId > 0 ? 'role="treeitem"' : 'role="option"');
            // Hide the current selected language or placeholder/empty-value option. Must use style, as tailwind "hidden" is not working.
            if (data.selected || data.placeholder || !data.value) {
                attrs.push('style="display: none;"');
            }

            return strToEl(
                `<div class="${css.join(" ")}" ${attrs.join(
                    " "
                )}>${customProperties ? `<img class="size-6" src="${customProperties}" alt=""/>` : ""}<span>${
                    data.label
                }</span></div>`
            );
        },
    });
    return { callbackOnCreateTemplates };
};
